export default "__VITE_ASSET__B9H$cAOf__"